import { defineComponent, ref, h, computed } from "@vue/composition-api";
import { StreamingHelper } from "@scrile/streaming-client";
import { isMobile } from "@/lib/browserUtils";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "MobileSwitchCam",
  props: {
    videoTracks: { type: Array as () => MediaStreamTrack[], required: true },
  },
  setup(props, { emit }) {
    const deviceId = computed(() => {
      if (props.videoTracks.length === 0) {
        return false;
      }
      return props.videoTracks[0].getSettings().deviceId ?? true;
    });
    const deviceList = ref<MediaDeviceInfo[]>([]);
    const facingMode = ref<"user" | "environment">("user");
    if (!isMobile()) {
      new StreamingHelper().getDeviceList().then(({ videoInputList }) => (deviceList.value = videoInputList));
    }

    const mobileSwitchCam = (): MediaTrackConstraints => {
      facingMode.value = facingMode.value === "user" ? "environment" : "user";
      return {
        facingMode: facingMode.value,
      };
    };

    const desktopSwitchCam = (): MediaTrackConstraints => {
      const index = deviceList.value.findIndex(i => i.deviceId === deviceId.value);
      const nextIndex = index === -1 ? 1 : index + 1;
      const deviceInfo = deviceList.value[nextIndex < deviceList.value.length ? nextIndex : 0];
      return {
        deviceId: { exact: deviceInfo.deviceId },
      };
    };

    const onClick = () => {
      let constraints: MediaTrackConstraints;
      if (isMobile()) {
        constraints = mobileSwitchCam();
      } else {
        if (!deviceId.value) {
          return;
        }
        constraints = desktopSwitchCam();
      }
      emit("changeDevice", { video: constraints });
    };
    return () => {
      if (!isMobile() && (!deviceId.value || deviceList.value.length < 2)) return h();
      return h(
        BaseIconButton,
        {
          on: { click: onClick },
          staticClass: "switch-cam",
        },
        ["sci-renew"]
      );
    };
  },
});
